export default "__VITE_ASSET__BNJtdg12__"